export default "/_next/static/images/5554447cd5d2eef4a8382dbf1065c530.png";